import {useRoute} from "ui.vue3.router";
import {useCoursesStore} from "../../stores/courses";

export const CategoryCourses = {
    setup() {
        const route = useRoute();
        const coursesStore = useCoursesStore();
    },
    template: `
        <div>list category courses</div>
    `
}